export default __webpack_public_path__ + "KaTeX_Size1-Regular.1876361fd46f2ba44d009dfd6fc09b83.woff2";